import axios from 'axios';
import React, { Fragment, useEffect, useState } from 'react';
import ReactDOM from "react-dom";
import { toast } from 'react-toastify';

const AdditionalDocumentsSelection = ({
    disabled,
    templateSettingId,
}) => {
    const [additionalDocuments, setAdditionalDocuments] = useState([]);

    const loadAdditionalDocuments = async () => {
        try {
            const response = await axios.get(route('web-api.additional-documents.append-list', {
                template_setting_id: templateSettingId,
            }));

            setAdditionalDocuments(response.data.sort((a, b) => {
                if (a.order === null && b.order === null) {
                    return 0
                }

                if (a.order === null) {
                    return 1
                }

                if (b.order === null) {
                    return -1
                }

                return a.order - b.order
            }));
        } catch (exception) {
            toast.error(<div>Could not load Additional Documents, please try again.</div>)
            console.log(exception)
        }
    };

    useEffect(() => {
        loadAdditionalDocuments();
    }, []);

    const handleChangeAll = (value) => {
        setAdditionalDocuments(
            additionalDocuments.map((additionalDocument) => ({
                ...additionalDocument,
                selected: value
            }))
        );
    }

    const handleChange = (selected) => {
        setAdditionalDocuments(additionalDocuments.map((additionalDocument) =>
            additionalDocument.additional_document_id === selected.additional_document_id
                ? { ...additionalDocument, selected: !additionalDocument.selected }
                : additionalDocument
        ));
    }

    const handleChangeOrder = (additionalDocument, direction) => {
        setAdditionalDocuments(docs => {
            const index = docs.findIndex(doc => doc.additional_document_id === additionalDocument.additional_document_id);
            if (index === -1) {
                return docs
            };

            let newIndex = direction === "up" ? index - 1 : index + 1;
            if (newIndex < 0 || newIndex >= docs.length) {
                return docs;
            }

            const newDocs = [...docs];
            [newDocs[index], newDocs[newIndex]] = [newDocs[newIndex], newDocs[index]];

            return newDocs.map((doc, i) => ({
                ...doc,
                order: i + 1
            }));
        });
    }

    const renderNoItems = () => {
        return (
            <div className="row empty">
                <p style={{
                    textAlign: 'center',
                    width: '100%',
                    padding: 12
                }}>
                    No Additional Documents
                </p>
            </div>
        )
    }

    const renderLineItemRow = (index, additionalDocument) => {
        return (
            <div className={"product-row"} key={additionalDocument.additional_document_id}>
                <div className="column order-column">
                    <div className={"order-controls"}>
                        <div className={index === 0 ? "up disabled" : "up"}
                             onClick={() => !disabled ? handleChangeOrder(additionalDocument, "up") : {}}
                        >
                            <i className="fas fa-arrow-alt-up fa-fw" />
                        </div>
                        <div className={index === additionalDocuments.length - 1 ? "down disabled" : "down"}
                             onClick={() => !disabled ? handleChangeOrder(additionalDocument, "down") : {}}
                        >
                            <i className="fas fa-arrow-alt-down fa-fw" />
                        </div>
                    </div>
                </div>
                <div className="column checkbox-column">
                    <input
                        type="checkbox"
                        checked={additionalDocument.selected}
                        disabled={disabled}
                        onChange={() => handleChange(additionalDocument)}
                    />
                </div>
                <div className="column with-border" style={{paddingRight: 10, paddingLeft: 10, width: '20%'}}>
                    <img src={additionalDocument.url} className={"m-0"} width={60} />
                </div>
                <div className="column with-border" style={{overflow: 'hidden', paddingRight: 10, paddingLeft: 10, width: '30%'}}>
                    <p className={"m-0"}>{additionalDocument.file_name}</p>
                </div>
                <div className="column with-border" style={{ paddingRight: 10, paddingLeft: 10, width: '25%'}}>
                    <p className={"m-0"}>{additionalDocument.user_name}</p>
                </div>
                <div className="column" style={{ paddingRight: 10, paddingLeft: 10, width: '25%'}}>
                    <p className={"m-0"}>{additionalDocument.created_at}</p>
                </div>
            </div>
        );
    }

    const getAllSelected = () => additionalDocuments.filter((additionalDocument) => additionalDocument.selected)

    return (
        <React.Fragment>
            <div className={"m-0 mb-4 quote-products-table"}>
                {getAllSelected().map((selectedAdditionalDocument, index) => (
                    <Fragment key={index}>
                        <input
                            type="hidden"
                            name={`additional_documents[${index}][id]`}
                            value={selectedAdditionalDocument.additional_document_id}
                        />
                        <input
                            type="hidden"
                            name={`additional_documents[${index}][order]`}
                            value={index}
                        />
                    </Fragment>
                ))}
                <div className={"product-table mb-3"}>
                    <div className="header">
                        <div className="column">

                        </div>
                        <div className="column checkbox-column">
                            <input
                                type="checkbox"
                                checked={getAllSelected().length === additionalDocuments.length}
                                disabled={disabled}
                                onChange={() => handleChangeAll(getAllSelected().length === additionalDocuments.length ? false : true)}
                            />
                        </div>
                        <div className="column with-border" style={{ paddingRight: 10, paddingLeft: 10, width: '20%'}}>
                            <span>Thumbnail</span>
                        </div>
                        <div className="column with-border" style={{ paddingRight: 10, paddingLeft: 10, width: '30%'}}>
                            <span>File Name</span>
                        </div>
                        <div className="column with-border" style={{ paddingRight: 10, paddingLeft: 10, width: '25%'}}>
                            <span>Uploaded By</span>
                        </div>
                        <div className="column" style={{ paddingRight: 10, paddingLeft: 10, width: '25%'}}>
                            <span>Created At</span>
                        </div>
                    </div>
                    {!!additionalDocuments && additionalDocuments.length > 0 ? additionalDocuments.map((additionalDocument, index) => renderLineItemRow(index, additionalDocument, additionalDocument.length)) : renderNoItems()}
                </div>
            </div>
        </React.Fragment>
    );
}

const container = document.getElementById('additional-documents-selection');

if (container) {
    ReactDOM.render(<AdditionalDocumentsSelection
        templateSettingId={container.dataset.templateSettingId}
    />, container);
}
